module.exports = __webpack_public_path__ + "static/img/avatar.0dc23d93.png";